export default __webpack_public_path__ + "static/media/DashBoardNewActive.63dc790d.svg";